// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__56-dk","colMin":"styles_colMin__1yQSV","colCheckbox":"styles_colCheckbox__3nSM4"};